import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-estimates-setting',
  templateUrl: './estimates-setting.component.html',
  styleUrls: ['./estimates-setting.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EstimatesSettingComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  public isspiner: boolean = false;
  currentUSer: any = JSON.parse(localStorage.getItem('currentUser'));
  private _unsubscribeAll$: Subject<void> = new Subject();
  CurrenctSymbol = '';
  estimateWarningLabel: string = 'You can set your standard threshold as a percentage';
  mattersLabel: string =
    'fill in the Matters above a certain Estimate $ field to set the $ amount this will apply to and then add in the percentage at which you want to be notified in the Higher Estimate Warning % field.';
  constructor(
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    const storedSymbol = localStorage.getItem('set_active_CURRENCYSYMBOL');
    this.CurrenctSymbol =
      storedSymbol && storedSymbol !== 'undefined' ? JSON.parse(storedSymbol) : '$';
    this.behaviorService.loadingSystemSetting('estimate');
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * save the estimates of system settings
   */
  saveEstimates() {
    this.isspiner = true;
    let data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'Thresholds',
      ESTIMATEWARNINGPERCENT: this.SettingForm.controls.ESTIMATEWARNINGPERCENT.value,
      ALLOWESTIMATERANGE: this.SettingForm.controls.ALLOWESTIMATERANGE.value,
      USEHIGHESTIMATEFORWARNING: this.SettingForm.controls.USEHIGHESTIMATEFORWARNING.value,
      ESTIMATENEXTTHRESHOLD: this.SettingForm.controls.ESTIMATENEXTTHRESHOLD.value,
      ESTIMATENEXTWARNINGPERCENT: this.SettingForm.controls.ESTIMATENEXTWARNINGPERCENT.value,
    };

    let data1 = { Action: 'Update', Data: data };
    (this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.isspiner = false;
          this.currentUSer['ALLOWESTIMATERANGE'] =
            this.SettingForm.controls.ALLOWESTIMATERANGE.value;
          this.currentUSer['USEHIGHESTIMATEFORWARNING'] =
            this.SettingForm.controls.USEHIGHESTIMATEFORWARNING.value;
          localStorage.setItem('currentUser', JSON.stringify(this.currentUSer));
          this.behaviorService.DELIVERABLES$.next(localStorage.getItem('set_active_DELIVERABLES'));
          this.toastr.success('Updated successfully');
        } else if ((response.CODE == 451 || response.CODE == 450) && response.STATUS == 'warning') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else {
          this.isspiner = false;
        }
      }),
      (error) => {
        this.isspiner = false;
        this.toastr.error(error);
      });
  }
}
